import { action, observable, makeObservable } from 'mobx';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { IDevicesData } from '@gem/call/CallStore/Me/Me.store.types';
import { CallBlurType } from '@gem/call/constants';
import { callBackground } from '@gem/call/storage/adapters';

export class MeStore {
  @observable isSpeaking = false;
  @observable isAudioMuted = true;
  @observable isVideoMuted = true;
  @observable isHandRaised = false;
  @observable handRaisedAt: number | null = null;
  @observable isSharedScreen = false;
  @observable isPlayingVideo = false;
  @observable id = '';
  @observable blurType = callBackground.getBlurBackgroundType() || CallBlurType.None;
  @observable shareScreenUid: ProviderUid | null = null;
  @observable audioVideoUid: ProviderUid | null = null;
  @observable audioVideoToken: string | null = null;
  @observable shareScreenToken: string | null = null;
  @observable deviceId: string | null = null;

  constructor(myId: string) {
    makeObservable(this);
    this.id = myId;
  }

  @action
  setDeviceData(data: IDevicesData): void {
    this.deviceId = data.deviceId;
    this.shareScreenUid = data.shareScreenUid;
    this.audioVideoUid = data.audioVideoUid;
    this.audioVideoToken = data.audioVideoToken;
    this.shareScreenToken = data.shareScreenToken;
  }

  @action
  setIsAudioMuted(isAudioMuted: boolean): void {
    this.isAudioMuted = isAudioMuted;
  }

  @action
  setIsVideoMuted(isVideoMuted: boolean): void {
    this.isVideoMuted = isVideoMuted;
  }

  @action
  setHandRaised(isHandRaised: boolean, ts: number | null = null): void {
    this.isHandRaised = isHandRaised;
    this.handRaisedAt = ts;
  }

  @action
  setIsSharedScreen(isSharedScreen: boolean): void {
    this.isSharedScreen = isSharedScreen;
  }

  @action
  setIsPlayingVideo(isPlayingVideo: boolean): void {
    this.isPlayingVideo = isPlayingVideo;
  }

  @action
  setBlur(blurType: CallBlurType): void {
    this.blurType = blurType;
    callBackground.setBlurBackgroundType(blurType);
  }

  @action
  setIsSpeaking(isSpeaking: boolean): void {
    this.isSpeaking = isSpeaking;
  }
}
